export const PAST_MILESTONE_TEST_ID = 'PastMilestone';
export const PAST_MILESTONE_NAME_TEST_ID = 'PastMilestoneName';
